import IconPhone from './IconPhone';
import IconMarker from './IconMarker';
import IconMail from './IconMail';
import IconClock from './IconClock';

export {
  IconPhone,
  IconMarker,
  IconMail,
  IconClock,
};



// WEBPACK FOOTER //
// ./public/js/components/Icons/index.js